import React from 'react';
import { useParams } from 'react-router-dom';

import BasePrompt from 'components/base/prompt/BasePrompt';

const ForceBurningPrompt = ({
  customerStatus = '',
  show = false,
  onCancel = () => {},
  onConfirm = () => {},
}) => {
  const params = useParams();
  return (
    <BasePrompt
      show={show}
      closeAction={onCancel}
      leftButton={{
        text: 'Cancel',
        action: onCancel,
      }}
      rightButton={{
        text: 'Confirm',
        action: onConfirm,
      }}
      title="Reminder"
      description={`The account status is ${customerStatus}. Are you sure to proceed?`}
    />
  );
};

export default ForceBurningPrompt;
